import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import RoundedButton from '@components/RoundedButton';

const messages = defineMessages({
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
  delete: {
    id: 'GLOBAL.delete',
    defaultMessage: 'Delete',
  },
});

/**
 * VITALL-styled button component for the routine form
 */
const Button = ({ ...props }: AppointmentForm.CommandButtonProps) => {
  const { formatMessage } = useIntl();
  const { id, onExecute } = props;
  switch (id) {
    case 'cancelButton':
      return (
        <Icon
          clickable
          color="text.secondary"
          name="xmark"
          onClick={onExecute}
          type="fas"
        />
      );
    case 'deleteButton':
      return (
        <RoundedButton
          autoSize
          height={30}
          margin={10}
          onClick={onExecute}
          style={{ marginLeft: 5 }}
          variant="red"
        >
          {formatMessage(messages.delete)}
        </RoundedButton>
      );
    case 'saveButton':
    default:
      return (
        <RoundedButton
          autoSize
          height={30}
          onClick={onExecute}
          style={{ marginLeft: 5 }}
        >
          {formatMessage(messages.save)}
        </RoundedButton>
      );
  }
};

export default Button;
